import styled from 'styled-components';

const ButtonRecipe = styled.button`
  width: ${(props) => props.width};
  height: 45px;
  background: ${(props) => props.backgroundColor};
  border: 1px solid ${(props) => props.borderColor};
  border-radius: 4px;
  opacity: 1;
  color: ${(props) => props.textColor};
  margin-left: ${(props) => props.marginLeft};
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0px;
  text-transform: uppercase;
  opacity: 1;
  transition: all 0.3s ease 0s;
  :hover {
    box-shadow: 5px 5px 15px 5px #d6d6d6;
  }
`;

export default ButtonRecipe;
